module.exports = __webpack_public_path__ + "media/images/featured-1-mobile-9718cf46392c8a1172be62ad808c4221.webp";